import { EntriModule, ModalsModule } from '@wix/domains-search-suite';
export const ENTRI_ENABLED_BY_SPEC = 'specs.premium.domain.enableEntriInConcierge';
export const divertConnectToEntriEligibility = async (_ref, _ref2) => {
  let {
    domainName,
    metaSiteId,
    siteName
  } = _ref;
  let {
    onConnectIntro,
    onConnectManual,
    onConnectError
  } = _ref2;
  const {
    loaderModal
  } = ModalsModule.internals.domainsSharedModalsController;
  try {
    loaderModal.show({});
    const {
      isEligible,
      isSpecEnabled
    } = await EntriModule.SDK.resolveEntriEligibility({
      domain: domainName,
      enabledBySpec: ENTRI_ENABLED_BY_SPEC
    });
    loaderModal.hide();
    if (isEligible && isSpecEnabled) {
      await (onConnectIntro == null ? void 0 : onConnectIntro({
        domainName,
        metaSiteId,
        siteName
      }));
      return;
    }
    await (onConnectManual == null ? void 0 : onConnectManual({
      domainName,
      metaSiteId
    }));
  } catch {
    loaderModal.hide();
    onConnectError == null || onConnectError();
  }
};
//# sourceMappingURL=connectEntriEligibility.js.map